import item from './item/item'
import { black } from 'ansi-colors'

export default function(o){

  var results = []

  var resultDivs = []

  var firstUpdate = true

  var itemWidth = null
  var itemHeight = null
  var totalColumns = null
  var documentWidth = null

  var calcSizes = function(){

    if(o.screenSize < 2){
      totalColumns = 2
    } else if(o.screenSize < 3){
      totalColumns = 3
    } else {
      totalColumns = 5
    }
    
    var scrollbarWidth = o.util.getScrollbarWidth()
    documentWidth = $('body').width() - 5 - scrollbarWidth
    itemWidth = documentWidth / totalColumns
    itemHeight = itemWidth / 4 * 3

  }

  var resize = function(){
    calcSizes()
    for (let index = 0; index < resultDivs.length; index++) {
      resultDivs[index].resize(itemWidth, itemHeight)
    }
  }

  var updateItems = function(e){

    var divHeight = div.height()
    var scrollTop = div.scrollTop()
    var scrollHeight = div[0].scrollHeight

    if(e){
      o.store('archiveScrollTop',scrollTop)
    }

    var firstVisibleRow = Math.floor(scrollTop / itemHeight) - 1
    var visibleRows = Math.floor(divHeight / itemHeight)
    var firstUnvisibleRow = firstVisibleRow + visibleRows + 3

    for (var i = 0; i < resultDivs.length; i++) {

      var resultRow =  Math.floor(i / totalColumns)

      var resultDiv = resultDivs[i]

      if(
        resultRow > firstVisibleRow &&
        resultRow < firstUnvisibleRow
      ){
        resultDiv.start()
      } else {
        resultDiv.stop()
      }

    }

  }

  var update = function(newResults){

    calcSizes()

    if(newResults){
      results = newResults
      resultDivs = []
      div.empty()
    }

    for (var i = 0; i < results.length; i++) {

      var result = results[i]

      var resultDiv =
        item(o, result, itemWidth, itemHeight)

      resultDivs.push(resultDiv)

      div.append(resultDiv)

    }

    updateItems()

  }

  var div =
    $('<div>')
    .addClass('ombArchiveGrid')
    .css({
      verticalAlign: 'top',
      lineHeight: 0,
      padding: 0,
      backgroundColor: 'black',
      borderLeft: '5px solid black',
      borderTop: '5px solid black',
    })
    .on('scroll', _.debounce(updateItems))

  div.update = update
  div.resize = resize

  o.gridDiv = div
  
  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/archive/grid/grid.js